// src/admin/contentAreas.js -- maps admin copy/config "areas" to their Firestore
// doc key, app-state read/write, and defaults (WP-5 Slice 2). Used by both the
// admin tabs (edit + save) and the read bridge (load Firestore -> app state).
import { DEFAULT_SITE_TEXT } from '../config/siteText.js';
import { DEFAULT_ACCOUNT } from '../config/account.js';
import { DEFAULT_BASKET, DEFAULT_TERMINOLOGY, DEFAULT_TERMINOLOGY_CATEGORIES } from '../config/basket.js';
import { DEFAULT_CHECKOUT } from '../config/checkout.js';
import { DEFAULT_BOOKING } from '../config/booking.js';
import { DEFAULT_TUTOR_REVIEW_SETTINGS } from '../config/tutorReview.js';
import { DEFAULT_EXAM_DATES } from '../config/account.js';

// /siteContent/{key}: one object per area (coarse keys, F1).
export const SITE_AREAS = {
    site_text: { label: 'Site Text', def: DEFAULT_SITE_TEXT, read: s => s.siteText, write: (s, v) => s.setSiteText(v) },
    account: { label: 'Account Copy', def: DEFAULT_ACCOUNT, read: s => s.accountContent, write: (s, v) => s.setAccountContent(v) },
    basket: { label: 'Cart Copy', def: DEFAULT_BASKET, read: s => s.basketContent, write: (s, v) => s.setBasketContent(v) },
    checkout: { label: 'Checkout Copy', def: DEFAULT_CHECKOUT, read: s => s.checkoutContent, write: (s, v) => s.setCheckoutContent(v) },
    booking: { label: 'Booking Copy', def: DEFAULT_BOOKING, read: s => s.bookingContent, write: (s, v) => s.setBookingContent(v) }
};

// /config/{key}: Doc #2 6.2 config docs.
export const CONFIG_AREAS = {
    terminology: {
        label: 'Terminology',
        def: { terms: DEFAULT_TERMINOLOGY, categories: DEFAULT_TERMINOLOGY_CATEGORIES },
        read: s => ({ terms: s.terminology || [], categories: s.terminologyCategories || [] }),
        write: (s, v) => {
            s.setTerminology(Array.isArray(v.terms) ? v.terms : []);
            s.setTerminologyCategories(Array.isArray(v.categories) ? v.categories : []);
        }
    },
    'tutor-review-settings': {
        label: 'Tutor Review',
        def: DEFAULT_TUTOR_REVIEW_SETTINGS,
        read: s => s.tutorReviewSettings,
        write: (s, v) => s.setTutorReviewSettings(v)
    },
    // Exam schedule (Danielle-managed). Doc content = { dates: [{ id, label, date }] }.
    // /config/exam-dates is already CF-allowlisted + public-read in rules (no rules change).
    'exam-dates': {
        label: 'Exam Dates',
        def: { dates: DEFAULT_EXAM_DATES },
        read: s => ({ dates: s.examDates || [] }),
        write: (s, v) => s.setExamDates(Array.isArray(v.dates) ? v.dates : [])
    }
};
